/**
 * 极简 path-based 路由（无 react-router 依赖）
 *
 * 支持：
 * - `/`            → { name: 'entry' }
 * - `/r/{4位数字}` → { name: 'room', roomCode }
 * - 其他           → { name: 'entry' }
 */
export type Route =
  | { name: 'entry' }
  | { name: 'room'; roomCode: string };

const ROOM_RE = /^\/r\/(\d{4})\/?$/;

export function parsePath(pathname: string): Route {
  const m = ROOM_RE.exec(pathname);
  if (m) return { name: 'room', roomCode: m[1] };
  return { name: 'entry' };
}

export function navigate(path: string): void {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === path) return;
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

import { useEffect, useState } from 'react';

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() =>
    typeof window === 'undefined' ? { name: 'entry' } : parsePath(window.location.pathname),
  );
  useEffect(() => {
    const onPop = (): void => setRoute(parsePath(window.location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);
  return route;
}
